export const GET_HASH_RESULT_REQUEST = 'GET_HASH_RESULT_REQUEST'
export const GET_HASH_RESULT_SUCCESS = 'GET_HASH_RESULT_SUCCESS'
export const GET_HASH_RESULT_FAILED = 'GET_HASH_RESULT_FAILED'

export const getHashResultAction = (data:any) => {
    return{type:GET_HASH_RESULT_REQUEST, payload:data}
}
